export enum ContactlessReaderOutputFormat {
  HEX = 'HEX',
  DECIMAL = 'DECIMAL',
  STRING = 'STRING',
}
